import * as t from 'io-ts';

export const id = t.number;

export const createdID = t.type({ id });

export const meta = t.type({ total: t.number, current_page: t.number, last_page: t.number });

export const links = t.type({
  first: t.union([t.string, t.null]),
  last: t.union([t.string, t.null]),
  next: t.union([t.string, t.null]),
  prev: t.union([t.string, t.null]),
});

export type Meta = t.TypeOf<typeof meta>;

export type Links = t.TypeOf<typeof links>;

export const emptyMeta = () => ({ total: 0, current_page: 1, last_page: 1 });

export const emptyLinks: () => Links = () => ({ first: null, next: null, last: null, prev: null });

export const emptyList = () => ({
  data: [],
  meta: emptyMeta(),
  links: emptyLinks(),
});

export const authorizedTo = t.type({
  view: t.boolean,
  update: t.boolean,
  delete: t.boolean,
});

export const checklistAuthorizedTo = t.type({
  view: t.boolean,
  update: t.boolean,
  delete: t.boolean,
  conduct: t.boolean,
});

export const user = t.type({
  id,
  data: t.type({
    id: t.union([t.number, t.undefined, t.null]),
    name: t.string,
  }),
});

export const form = t.type({
  id,
  data: t.type({
    id: t.union([t.number, t.undefined, t.null]),
    title: t.union([t.string, t.null]),
  }),
});

export const users = t.array(user);
export const nullableUser = t.union([user, t.null]);
export const stringOrNull = t.union([t.string, t.null]);
export const numberOrNull = t.union([t.number, t.null]);

export const forms = t.array(form);

export const entityItem = t.type({
  id,
  data: t.type({ title: t.string }),
});

export const entityFolder = t.type({
  id,
  title: t.string,
  data: t.type({ title: t.string }),
});

export const entityType = t.type({
  id,
  data: t.type({ title: t.string }),
});

export const role = t.type({
  id,
  data: t.type({ title: t.string }),
});

export const group = t.type({
  id,
  data: t.type({ title: t.string }),
});

export const groups = t.array(group);
export const entityItems = t.array(entityItem);
export const entityFolders = t.array(entityFolder);
export const roles = t.array(role);

export const targetForm = t.type({
  administrators: t.boolean,
  users: t.array(id),
  groups: t.array(id),
  entityItems: t.array(id),
  roles: t.array(id),
});

export const target = t.type({
  id,
  data: targetForm,
});

export const score = t.union([t.number, t.string, t.null]);
